import { ApiResponse } from '@interfaces/api-response/1.0';
import { BooleanSettings, GenericTemplate, ServiceType, TenderType } from '@generated/tcea/models';

export interface Aggregator {
  id: string;
  name: string;
  settings?: Settings[];
  configurations?: { [key: string]: string }[];
  orderingChannels?: OrderingChannels[];
  deliveryProviders?: DeliveryProvider[];
}

export interface DeliveryProvider {
  id: string;
  displayName: string;
  description?: string;
  enabled: boolean;
}

export interface Settings {
  name: string;
  id: string;
}

export interface AggregatorsResponse extends ApiResponse {
  _embedded: {
    aggregator: Aggregator[];
  };
}

export interface AggregatorConfig {
  aggregatorId: string;
  tenderId: string;
  accountId?: string;
  tenderType: TenderType;
  surcharge: number;
  aggregatorStoreId?: string;
  parentStoreId?: string;
  parentAggregatorStoreId?: string;
  parentStoreName?: string;
  parentStoreNumber?: string;
  extendedConfig?: string | { [key: string]: string | number | boolean };
  extendedConfigFields?: {
    [key: string]: string | number | boolean;
  };
  aggregatorTenantId?: string;
  publishTaxCategoriesWithItem?: boolean;
  enabled?: boolean;
  dualPricingEnabled?: boolean;
  aorEnabled?: boolean;
  serviceTypes?: {};
  serviceType?: ServiceType;
  serviceFee?: {
    type: ServiceFeeType;
    value?: number;
  };
  orderPause?: OrderPause;
  settings?: BooleanSettings;
  comment?: string;
  tenderConfigurations?: GenericTemplate[];
  displayDelayedOrderInjection?: boolean;
  delayedOrderInjection?: DelayedOrderMethods;
  rollUpContainerPrice?: boolean;
  excludeMenuPublishes?: boolean;
}

export interface OrderPause {
  started: string;
  pausedUntil: string;
  pauseType: string;
  paused: boolean;
}

export enum ServiceFeeType {
  NONE = '',
  PERCENTAGE = 'percentage',
  AMOUNT = 'amount',
}

export interface TenderTypeRow {
  channel: string;
  serviceType: string[];
  tenderName: string[];
  commonServiceTypes?: string;
  paymentLocations?: {
    [key: string]: boolean;
  };
}

export enum OnboardingType {
  Start = 'start',
  Pending = 'pending',
  Confirmed = 'confirmed',
  Error = 'error',
  MenuPulled = 'menu_pulled',
  RestartOnboarding = 'restart_onboarding',
}

export enum OrderingChannels {
  WEB = 'web',
  MOBILE = 'mobile',
  CALL_CENTER = 'call_center',
  KIOSK = 'kiosk',
  INDOOR_DIGITAL_MENU_BOARD = 'indoor_digital_menu_board',
  OUTDOOR_DIGITAL_MENU_BOARD = 'outdoor_digital_menu_board',
  CHAT = 'chat',
}

export enum CouponOrderingChannels {
  BROWSER = 'browser',
  MOBILE_APP = 'mobile_app',
  CALL_CENTER = 'call_center',
  POS_LOYALTY = 'pos_loyalty',
  KIOSK = 'kiosk',
}

export enum DelayedOrderMethods {
  DRIVER_ARRIVAL = 'DRIVER_ARRIVAL',
  ESTIMATED_PICKUP = 'ESTIMATED_PICKUP',
}
